import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'

Vue.use(VueRouter);

  const routes = [
  {
    path: '/register',
    name: 'signup',
    component: () => import('../components/Signup.vue')
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../components/Login.vue'),
    beforeEnter(to, from, next) {
      if (!store.getters.user) {
        next()
      } else {
        next({
          name: 'home'
        })
      }
    }
  },
  // {
  //   path: '/forgot-password',
  //   name: 'forgot-password',
  //   component: () => import('../components/ForgotPassword.vue')
  // },
  {
    path: '/',
    name: 'home',
    component: () => import('../components/Home.vue')
  },
  {
    path: '/team/create',
    name: 'add',
    component: () => import('../components/UserCreate.vue'),
    beforeEnter(to, from, next) {
      if (store.getters.user && to.path !== '/login') {
        next()
      } else {
        next({
          name: 'login'
        })
      }
    }
  },
  {
    path: '/list',
    name: 'list',
    component: () => import('../components/UserList.vue')
  },
  {
    path: '/team/:id/edit',
    name: 'edit',
    component: () => import('../components/UserEdit.vue'),
    beforeEnter(to, from, next) {
      if (store.getters.user && to.path !== '/login') {
        next()
      } else {
        next({
          name: 'login'
        })
      }
    }
  },
  {
    path: '/team/:id',
    name: 'detail',
    component: () => import('../components/UserDetail.vue')
  },
  {
    path: '/team',
    name: 'team',
    component: () => import('../components/About.vue')
  },
  {
    path: '/services',
    name: 'services',
    component: () => import('../components/services/ServiceList.vue')
  },
  {
    path: '/services/create',
    name: 'createService',
    component: () => import('../components/services/ServiceCreate.vue'),
    beforeEnter(to, from, next) {
      if (store.getters.user && to.path !== '/login') {
        next()
      } else {
        next({
          name: 'login'
        })
      }
    }
  },
  {
    path: '/services/:id',
    name: 'detailService',
    component: () => import('../components/services/ServiceDetail.vue')
  },
  {
    path: '/services/:id/edit',
    name: 'editService',
    component: () => import('../components/services/ServiceEdit.vue'),
    beforeEnter(to, from, next) {
      if (store.getters.user && to.path !== '/login') {
        next()
      } else {
        next({
          name: 'login'
        })
      }
    }
  },
  {
    path: '/news',
    name: 'news',
    component: () => import('../components/news/NewsList.vue')
  },
  {
    path: '/news/create',
    name: 'newsCreate',
    component: () => import('../components/news/NewsCreate.vue'),
    beforeEnter(to, from, next) {
      if (store.getters.user && to.path !== '/login') {
        next()
      } else {
        next({
          name: 'login'
        })
      }
    }
  },
  {
    path: '/news/:id',
    name: 'newsDetail',
    component: () => import('../components/news/NewsDetail.vue')
  },
  {
    path: '/news/:id/edit',
    name: 'newsEdit',
    component: () => import('../components/news/NewsEdit.vue'),
    beforeEnter(to, from, next) {
      if (store.getters.user && to.path !== '/login') {
        next()
      } else {
        next({
          name: 'login'
        })
      }
    }
  },
  {
    path: '/interesting',
    name: 'interestingList',
    component: () => import('../components/interesting/InterestingList.vue')
  },
  {
    path: '/interesting/create',
    name: 'interestingCreate',
    component: () => import('../components/interesting/InterestingCreate.vue'),
    beforeEnter(to, from, next) {
      if (store.getters.user && to.path !== '/login') {
        next()
      } else {
        next({
          name: 'login'
        })
      }
    }
  },
  {
    path: '/interesting/:id/edit',
    name: 'interestingEdit',
    component: () => import('../components/interesting/InterestingEdit.vue'),
    beforeEnter(to, from, next) {
      if (store.getters.user && to.path !== '/login') {
        next()
      } else {
        next({
          name: 'login'
        })
      }
    }
  },
  {
    path: '/interesting/:id',
    name: 'interestingDetail',
    component: () => import('../components/interesting/InterestingDetail.vue')
  },
    {
      path: '/tips',
      name: 'tipsList',
      component: () => import('../components/tips/tipsList.vue')
    },
    {
      path: '/tips/create',
      name: 'tipsCreate',
      component: () => import('../components/tips/tipsCreate.vue'),
      beforeEnter(to, from, next) {
        if (store.getters.user && to.path !== '/login') {
          next()
        } else {
          next({
            name: 'login'
          })
        }
      }
    },
    {
      path: '/tips/:id/edit',
      name: 'tipsEdit',
      component: () => import('../components/tips/tipsEdit.vue'),
      beforeEnter(to, from, next) {
        if (store.getters.user && to.path !== '/login') {
          next()
        } else {
          next({
            name: 'login'
          })
        }
      }
    },
    {
      path: '/tips/:id',
      name: 'tipsDetail',
      component: () => import('../components/tips/tipsDetail.vue')
    },
  {
    path: '/gallery/create',
    name: 'galleryCreate',
    component: () => import('../components/gallery/GalleryCreate.vue'),
    beforeEnter(to, from, next) {
      if (store.getters.user && to.path !== '/login') {
        next()
      } else {
        next({
          name: 'login'
        })
      }
    }
  },
  {
    path: '/counters/create',
    name: 'countersCreate',
    component: () => import('../components/counters/CountersCreate.vue'),

  },
  {
    path: '/grooming',
    name: 'grooming',
    component: () => import('../components/grooming/Grooming.vue')
  },
  {
    path: '/gallery',
    name: 'galleryList',
    component: () => import('../components/gallery/GalleryList.vue')
  },
  {
    path: '/prices',
    name: 'prices',
    component: () => import('../components/prices/prices.vue')
  },
  {
    path: '/prices/create',
    name: 'CreatePrice',
    component: () => import('../components/prices/CreatePrices.vue')
  },
  {
    path: '/contacts',
    name: 'contacts',
    component: () => import('../components/contacts/Contacts.vue')
  },
  {
    path: '*',
    component: () => import('../components/Home.vue')
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior (to) {
    if (to.hash) { // if has a hash...
      return { selector: to.hash } // scroll to the element
    }
    return { x: 0, y: 0, behavior: 'smooth' }
  }
});

export default router

